var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _circle2, _circle3, _path23, _circle4, _path24, _circle5, _path25, _circle6, _path26, _circle7, _path27, _circle8, _path28, _circle9, _path29, _circle10, _path30, _circle11, _path31, _circle12, _path32, _circle13, _path33, _circle14, _path34;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoRespondents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 150,
    viewBox: "0 0 288 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206 75C206 116.421 172.421 150 131 150C89.5786 150 56 116.421 56 75C56 33.5786 89.5786 0 131 0C172.421 0 206 33.5786 206 75Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220.572 118.815H96.032C93.5717 118.815 91.6035 116.839 91.6035 114.37V32.6472C91.6035 30.1782 93.5717 28.203 96.032 28.203H220.572C223.032 28.203 225 30.1782 225 32.6472V114.42C225 116.839 223.032 118.815 220.572 118.815Z",
    fill: "#D0ECF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225 109.679H91.6035V28.708C91.6035 26.1505 93.5717 24.1045 96.032 24.1045H220.572C223.032 24.1045 225 26.1505 225 28.708V109.679Z",
    fill: "#117BC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.321 25.3634H96.5503C94.7254 25.3634 93.2461 26.8436 93.2461 28.6696V108.368H223.625V28.6696C223.625 26.8436 222.146 25.3634 220.321 25.3634Z",
    fill: "#EBF7F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.334 118.815H143.319V135.11H173.334V118.815Z",
    fill: "#D0ECF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.84 134.884H132.763C132.179 134.884 131.706 135.358 131.706 135.942C131.706 136.526 132.179 137 132.763 137H183.84C184.424 137 184.897 136.526 184.897 135.942C184.897 135.358 184.424 134.884 183.84 134.884Z",
    fill: "#D0ECF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.223 116.562C159.59 116.562 160.699 115.453 160.699 114.084C160.699 112.716 159.59 111.607 158.223 111.607C156.856 111.607 155.748 112.716 155.748 114.084C155.748 115.453 156.856 116.562 158.223 116.562Z",
    fill: "#A0DDE4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.334 125.777L143.319 130.221V118.815H173.334V125.777Z",
    fill: "#A0DDE4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.228 35.9563C104.228 34.4347 105.46 33.2012 106.981 33.2012H212.362C213.883 33.2012 215.116 34.4347 215.116 35.9563V99.2725C215.116 100.794 213.883 102.028 212.362 102.028H106.981C105.46 102.028 104.228 100.794 104.228 99.2725V35.9563Z",
    fill: "#D5E7E9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.104 34.6332C103.104 33.1116 104.337 31.8781 105.858 31.8781H211.239C212.76 31.8781 213.993 33.1116 213.993 34.6332V97.9494C213.993 99.471 212.76 100.705 211.239 100.705H105.858C104.337 100.705 103.104 99.471 103.104 97.9494V34.6332Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.104 34.6332C103.104 33.1116 104.337 31.8781 105.858 31.8781H211.239C212.76 31.8781 213.993 33.1116 213.993 34.6332V37.9337H103.104V34.6332Z",
    fill: "#04B7EF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M209.904 34.9064C209.904 35.5146 209.411 36.0076 208.803 36.0076C208.196 36.0076 207.703 35.5146 207.703 34.9064C207.703 34.2982 208.196 33.8052 208.803 33.8052C209.411 33.8052 209.904 34.2982 209.904 34.9064Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M205.778 34.9064C205.778 35.5146 205.285 36.0076 204.677 36.0076C204.07 36.0076 203.577 35.5146 203.577 34.9064C203.577 34.2982 204.07 33.8052 204.677 33.8052C205.285 33.8052 205.778 34.2982 205.778 34.9064Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M201.652 34.9064C201.652 35.5146 201.159 36.0076 200.551 36.0076C199.944 36.0076 199.451 35.5146 199.451 34.9064C199.451 34.2982 199.944 33.8052 200.551 33.8052C201.159 33.8052 201.652 34.2982 201.652 34.9064Z",
    fill: "#ED509B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 113.547,
    y: 63.4268,
    width: 23.2972,
    height: 10.4965,
    rx: 0.4,
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M125.56 58.7979V61.8563H126.535V58.7563C127.178 58.5482 127.655 57.9865 127.655 57.2999C127.655 56.4469 126.908 55.7603 125.975 55.7603C125.062 55.7603 124.295 56.4469 124.295 57.2999C124.316 58.0281 124.855 58.6315 125.56 58.7979Z",
    fill: "#01AAE0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M114.838 62.3348C113.532 62.3973 112.474 63.4167 112.37 64.7066H115.315C115.336 64.7066 115.336 64.7066 115.357 64.7066H133.776V62.3348H114.838Z",
    fill: "#0ED6E5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M137.011 62.3348H136.866V65.0395C136.866 65.0603 136.866 65.0603 136.866 65.0811V73.2576H139.5V64.9563C139.479 63.5415 138.38 62.3973 137.011 62.3348Z",
    fill: "#13E0F9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M133.753 62.3348V64.7066H136.471C136.657 64.7066 136.823 64.8523 136.844 65.0395V62.3348H133.753Z",
    fill: "#0CC4E2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M136.159 73.9231H133.068V76.2949H136.159V73.9231Z",
    fill: "#01AAE0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M112.348 64.9563V67.8066H114.982V65.0811C114.982 64.8939 115.128 64.7274 115.314 64.7066H112.369C112.348 64.7899 112.348 64.8731 112.348 64.9563Z",
    fill: "#0092C0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M114.982 73.549V67.8068H112.348V73.6739C112.348 75.1302 113.51 76.2953 114.962 76.2953H114.982V73.5906C114.982 73.5698 114.982 73.5698 114.982 73.549Z",
    fill: "#01AAE0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M133.069 73.9233H115.356C115.169 73.9233 115.003 73.7777 114.982 73.5904V76.2951H133.069V73.9233Z",
    fill: "#117BC7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 133.576,
    cy: 69.3373,
    r: 1.72293,
    fill: "#3F3F3F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.955,
    cy: 69.3373,
    r: 1.72293,
    fill: "#3F3F3F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.713,
    cy: 49.7022,
    r: 2.63965,
    fill: "#F3F3F3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M151.677 56.719C151.677 54.7257 153.292 53.1097 155.286 53.1097H156.141C158.134 53.1097 159.75 54.7257 159.75 56.719H151.677Z",
    fill: "#F3F3F3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.787,
    cy: 49.7022,
    r: 2.63965,
    fill: "#F3F3F3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M165.75 56.719C165.75 54.7257 167.366 53.1097 169.359 53.1097H170.214C172.208 53.1097 173.823 54.7257 173.823 56.719H165.75Z",
    fill: "#F3F3F3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.86,
    cy: 49.7022,
    r: 2.63965,
    fill: "#F3F3F3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M179.823 56.719C179.823 54.7257 181.439 53.1097 183.433 53.1097H184.288C186.281 53.1097 187.897 54.7257 187.897 56.719H179.823Z",
    fill: "#F3F3F3"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.934,
    cy: 49.7022,
    r: 2.63965,
    fill: "#F3F3F3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M193.897 56.719C193.897 54.7257 195.513 53.1097 197.506 53.1097H198.361C200.355 53.1097 201.97 54.7257 201.97 56.719H193.897Z",
    fill: "#F3F3F3"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.713,
    cy: 66.3587,
    r: 2.63965,
    fill: "#F3F3F3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M151.677 73.3756C151.677 71.3822 153.292 69.7662 155.286 69.7662H156.141C158.134 69.7662 159.75 71.3822 159.75 73.3756H151.677Z",
    fill: "#F3F3F3"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.787,
    cy: 66.3587,
    r: 2.63965,
    fill: "#F3F3F3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M165.75 73.3756C165.75 71.3822 167.366 69.7662 169.359 69.7662H170.214C172.208 69.7662 173.823 71.3822 173.823 73.3756H165.75Z",
    fill: "#F3F3F3"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.86,
    cy: 66.3587,
    r: 2.63965,
    fill: "#F3F3F3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M179.823 73.3756C179.823 71.3822 181.439 69.7662 183.433 69.7662H184.288C186.281 69.7662 187.897 71.3822 187.897 73.3756H179.823Z",
    fill: "#F3F3F3"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.934,
    cy: 66.3587,
    r: 2.63965,
    fill: "#F3F3F3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M193.897 73.3756C193.897 71.3822 195.513 69.7662 197.506 69.7662H198.361C200.355 69.7662 201.97 71.3822 201.97 73.3756H193.897Z",
    fill: "#F3F3F3"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.713,
    cy: 83.0152,
    r: 2.63965,
    fill: "#F3F3F3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M151.677 90.0321C151.677 88.0387 153.292 86.4228 155.286 86.4228H156.141C158.134 86.4228 159.75 88.0387 159.75 90.0321H151.677Z",
    fill: "#F3F3F3"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.787,
    cy: 83.0152,
    r: 2.63965,
    fill: "#F3F3F3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M165.75 90.0321C165.75 88.0387 167.366 86.4228 169.359 86.4228H170.214C172.208 86.4228 173.823 88.0387 173.823 90.0321H165.75Z",
    fill: "#F3F3F3"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.86,
    cy: 83.0152,
    r: 2.63965,
    fill: "#F3F3F3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M179.823 90.0321C179.823 88.0387 181.439 86.4228 183.433 86.4228H184.288C186.281 86.4228 187.897 88.0387 187.897 90.0321H179.823Z",
    fill: "#F3F3F3"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.934,
    cy: 83.0152,
    r: 2.63965,
    fill: "#F3F3F3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M193.897 90.0321C193.897 88.0387 195.513 86.4228 197.506 86.4228H198.361C200.355 86.4228 201.97 88.0387 201.97 90.0321H193.897Z",
    fill: "#F3F3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRespondents);
export default __webpack_public_path__ + "static/media/NoRespondents.06ad6d5e283bffa6bebc6eb974d913c3.svg";
export { ForwardRef as ReactComponent };